import React, { Component } from "react";
import { connect } from "react-redux";

import { Copy, Wrapper } from "app/NativeComponents/common";
import { List, SearchBar, SpinWrapper } from "app/NativeComponents/snippets";
import {
  getNeverCallList,
  removePhoneNumberFromNeverCallList
} from "app/NativeActions";
import NeverCallListItem from "./NeverCallListItem";
class NeverCallList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      never_call_phone_numbers: [],
      never_call_loading: false,
      never_call_refreshing: false,
      never_call_loaded_all: false,
      never_call_limit: 100,
      never_call_begin: 0,
      never_call_count: 0,
      never_call_count_loading: false,
      search: ""
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.getData({ load_type: "load" });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.search !== this.state.search) {
      // Clear any existing timer
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // Set a new timer to debounce the search
      this.searchTimer = setTimeout(() => {
        this.getData({ load_type: "refresh" });
      }, 500); // 500ms debounce time
    }
  }

  componentWillUnmount() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  }

  getData({ load_type = "load" }) {
    if (!this.props.never_call_loading && !this.state.never_call_refreshing) {
      this.setState(
        {
          never_call_begin:
            load_type === "load" || load_type === "refresh"
              ? 0
              : this.state.never_call_begin + this.state.never_call_limit,
          never_call_phone_numbers:
            load_type === "refresh" ? [] : this.state.never_call_phone_numbers,
          never_call_loading: true,
          never_call_refreshing: load_type === "refresh"
        },
        () => {
          this.props.getNeverCallList({
            token: this.props.token,
            limit: this.state.never_call_limit,
            begin: this.state.never_call_begin,
            search: this.state.search,
            onLoading: () => {
              this.setState({
                never_call_loading: true
              });
            },
            onError: () => {
              this.setState(
                {
                  never_call_loading: false,
                  never_call_refreshing: false
                },
                () => {
                  this.setState({
                    never_call_loading: false
                  });
                }
              );
            },
            onSuccess: results => {
              if (results?.never_call_phone_numbers) {
                this.setState(
                  {
                    never_call_loading: false,
                    never_call_refreshing: false,
                    never_call_phone_numbers:
                      load_type === "load_more"
                        ? [
                            ...this.state.never_call_phone_numbers,
                            ...results.never_call_phone_numbers
                          ]
                        : results.never_call_phone_numbers,
                    never_call_loaded_all:
                      results.never_call_phone_numbers?.length <
                      this.state.never_call_limit
                  },
                  () => {}
                );
              }
            }
          });
        }
      );
    }
  }

  render() {
    const { colors } = this.props;
    const {
      never_call_phone_numbers,
      never_call_loading,
      never_call_refreshing,
      never_call_loaded_all
    } = this.state;

    return (
      <>
        <SearchBar
          title={"Search Phone Numbers"}
          onChange={value => {
            this.setState({
              search: value
            });
          }}
          value={this.state.search}
          style={{
            margin: 10
          }}
        />

        {never_call_phone_numbers?.length > 0 ? (
          <List
            rowNumber={1}
            items={never_call_phone_numbers}
            infiniteScroll={true}
            itemStructure={({ item, index }) => {
              return (
                <NeverCallListItem
                  item={item}
                  removePhoneNumberFromNeverCallList={
                    this.props.removePhoneNumberFromNeverCallList
                  }
                  isMobile={this.props.isMobile}
                  token={this.props.token}
                  onRemove={item => this.handleRemoveFromNeverCallList(item)}
                />
              );
            }}
            canRefresh={false}
            onRefresh={() => {}}
            is_refreshing={false}
            canLoadMore={
              !never_call_loaded_all &&
              !never_call_loading &&
              never_call_phone_numbers?.length > 0
            }
            isLoadingMore={
              never_call_loading && never_call_phone_numbers?.length > 0
            }
            onLoadMore={() => {
              if (!never_call_loaded_all && never_call_loading !== true) {
                this.getData({ load_type: "load_more" });
              }
            }}
          />
        ) : this.state.never_call_loading ? (
          <SpinWrapper text="Loading..." />
        ) : (
          <Wrapper
            style={{
              padding: 25,
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Copy>No phone numbers found.</Copy>
          </Wrapper>
        )}
      </>
    );
  }

  handleRemoveFromNeverCallList(item) {
    const updatedList = this.state.never_call_phone_numbers.filter(
      phone => phone.phone_number !== item.phone_number
    );

    this.setState({
      never_call_phone_numbers: updatedList
    });
  }

  componentWillUnmount() {
    // Clear any pending timer when component unmounts
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  }
}

const mapStateToProps = ({ auth, settings, native, dialer, team }) => {
  const { token, user } = auth;

  const { colors } = settings;
  const { platform, device, isMobile } = native;

  return {
    token,
    user,
    colors,
    device,
    isMobile,
    platform
  };
};

export default connect(mapStateToProps, {
  getNeverCallList,
  removePhoneNumberFromNeverCallList
})(NeverCallList);
